import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import Mail_Lottie from "../../../animation/mail_lottie/Mail_Lottie";
import Orange_White_Border_Btn from "../../common_btn/orange_white_border_btn/Orange_White_Border_Btn";
import "./Verification_Steps_Modal.css";
import Phone_Lottie from "../../../animation/phone_lottie/Phone_Lottie";
import Profile_Info_Lottie from "../../../animation/profile_info_lottie/Profile_Info_Lottie";
import Id_Proof_Lottie from "../../../animation/id_proof_lottie/Id_Proof_Lottie";
import Verify_Profile_Modal from "../verify_profile_modal/Verify_Profile_Modal";

const Verification_Steps_Modal = (props) => {
  const [showModal, setShowModal] = useState(false);
  const steps = [
    {
      step: 1,
      title: "01.Confirm Email Address",
      subtitle: "rishi.karekar@Profcyma.In",
      status: "completed",
    },
    {
      step: 2,
      title: "02. Confirm Phone Number",
      subtitle: "Make Your Account More Secure",
      status: "completed",
    },
    {
      step: 3,
      title: "03. Add Profile Information",
      subtitle: "Get A More Tailored Experience",
      status: "completed",
    },
    {
      step: 4,
      title: "04. Add Id Proof",
      subtitle: "Verify Your Profile With Identification",
      status: "",
    },
  ];

  return (
    <section className="Verification_Steps_Modal">
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="Verification_Steps_Modal modal-holder"
      >
        <Modal.Header closeButton>
          <Modal.Title>Verification Steps</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="note_div">
            <p className="note">This Process Takes Less Than 5 Minutes</p>
          </div>

          <div className="steps_holder">
            <div className="row">
              {steps?.map((item) => {
                return (
                  <div className="col-lg-3">
                    <div className="step_div">
                      <p
                        className={`title_text ${
                          item.status === "completed" ? "completed" : ""
                        }`}
                      >
                        {item?.title}
                      </p>
                      <div
                        className={`animation_holder ${
                          item.status === "completed" ? "completed" : ""
                        }`}
                      >
                        {item?.step === 1 ? (
                          <Mail_Lottie />
                        ) : item?.step === 2 ? (
                          <Phone_Lottie />
                        ) : item?.step === 3 ? (
                          <Profile_Info_Lottie />
                        ) : (
                          <Id_Proof_Lottie />
                        )}
                      </div>
                      <p className="subtitle_text">{item?.subtitle}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="btn_holder">
            <Orange_White_Border_Btn
              btn_name="Add Id Proof"
              onClick={() => {
                setShowModal(true);
                props?.onHide();
              }}
            />
          </div>

          <p
            className="do_it_text"
            onClick={() => {
              props?.onHide();
            }}
          >
            Do It Later
          </p>
        </Modal.Body>
      </Modal>
      <Verify_Profile_Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
        // setFormSubmitted={setFormSubmitted}
        // setStepCompleted={setStepCompleted}
      />
    </section>
  );
};

export default Verification_Steps_Modal;
